import { render } from "./ProductDetail.vue?vue&type=template&id=2474aa68&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=2474aa68&lang=scss&scoped=scoped"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2474aa68"]])

export default __exports__